import React from 'react';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

// types
import { HistoryEvent } from './types';

// Utils
import { formatDate } from 'Shared/utils/DateTime.utils';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './HistoryEventsItem.scss';

type Props = {
  event: HistoryEvent;
};
const HistoryEventsItem = ({ event }: Props) => {
  const baseClassName = 'HistoryEventsItem';

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__label`}>
        <span className={`${baseClassName}__label__bold`}>{event.userName}</span> {event.title}
        <span className={`${baseClassName}__label__time`}>
          &nbsp;-&nbsp;{formatDate(event.timestamp, 'M/D/YYYY h:mma')}
        </span>
      </div>
      {event.before && event.after && (
        <div className={`${baseClassName}__value`}>
          <span className={`${baseClassName}__value__before`}>{event.before}</span>
          <span className={`${baseClassName}__value__arrow`}>
            <WpIcon name="long-arrow-right" color={Colors.gray[700]} />
          </span>
          <span className={`${baseClassName}__value__after`}>{event.after}</span>
        </div>
      )}
    </div>
  );
};

export default HistoryEventsItem;
